/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetAllIneligibleCPT = (data) => ({
  type: actionTypes.GET_ALL_INELIGIBLE_CPT_DATA,
  ineligibleCPTListData: data,
});
export const getAllIneligibleCPT = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INELIGIBLE_CPT_LIST, value)
    .then((response) => {
      let newObj = [];
      newObj = response.data?.data?.map((item) => {
        item.tempId = uuidv4();
        item.isFromAPI = true;
        return item;
      });
      dispatch(
        dispatchGetAllIneligibleCPT({
          ...response.data,
          data: newObj,
        })
      );
    })
    .catch((err) => {
      if (err?.response?.status == 401) return;
      dispatch(dispatchGetAllIneligibleCPT({ error: 'API failed' }));
    });
};

export const setErrorMessages = (payload) => {
  return {
    type: actionTypes.HANDLE_ERROR_MESSAGE_MICPT,
    payload,
  };
};

export const setGridData = (payload) => {
  return {
    type: actionTypes.SET_GRID_DATA_INELIGIBLE_CPT,
    payload,
  };
};
export const setUpdateIneligibleCPtPrvRes = (payload) => {
  return {
    type: actionTypes.INELIGIBLE_CPT_ADD_EDIT_RES,
    payload,
  };
};
export const updateIneligibleCpt = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_INELIGIBLE_CPT, values)
    .then((response) => {
      if (response.status === '001') {
        dispatch(setUpdateIneligibleCPtPrvRes('SUCCESS'));
      }
      return response.data;
    })
    .catch((error) => {
      dispatch(setUpdateIneligibleCPtPrvRes('failed'));
      return error;
    });
};
export const resetIneligibleCPTStore = () => {
  return {
    type: actionTypes.RESET_INELIGIBLE_CPT_REDUX_STORE,
  };
};
export const setDeletedData = (payload) => {
  return {
    type: actionTypes.SET_DELETED_DATA_INELIGIBLE_CPT,
    payload,
  };
};
export const validateIneligibleProvider = (values) => {
  return axios
    .post(serviceEndPoint.VALIDATE_INELIGIBLE_PROVIDER, values)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};
